import { render } from "./ambassador_request.vue?vue&type=template&id=719915fc"
import script from "./ambassador_request.vue?vue&type=script&lang=js"
export * from "./ambassador_request.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__